module.exports = __webpack_public_path__ + "img/salon-atmosphere.f66e7a6d.svg";